import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { UsersList } from './UsersList';
import { fetchUsers } from '../redux/user-list/actions';
import { getUsersListState } from '../redux/user-list/selectors';
import PageHeaderWithButtons from '../../../../../shared/headers/PageHeaderWithButtons';
import { AddButton } from '../../../../../shared/button/AddButton';
import {
    extendWithModalSupport,
    ModalContainer
} from '../../../../../shared/modal-container/ModalContainer';
import CreateUser from '../create-user/CreateUser';

class UsersListContainer extends Component {
    constructor(props) {
        super(props);
        extendWithModalSupport(this);
    }
    buttons = [
        <AddButton
            key={'add-user'}
            label={'Add User'}
            onClick={() => this.modalInstance.openModal()}
        />
    ];

    componentDidMount() {
        this.props.fetchUsers && this.props.fetchUsers();
    }

    render() {
        const { users, loading } = this.props;

        return (
            <div className={'core-content-container'}>
                <PageHeaderWithButtons buttons={this.buttons} />
                <UsersList users={users} loading={loading} />
                <ModalContainer
                    title={'Create User'}
                    content={
                        <CreateUser
                            closeModal={() => this.modalInstance.closeModal()}
                        />
                    }
                    ref={this.modalRef}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { loaded, loading, error, data } = getUsersListState(state);

    return {
        users: data,
        loaded,
        loading,
        error
    };
};
const mapDispatchToProps = dispatch => ({
    fetchUsers: () => dispatch(fetchUsers())
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UsersListContainer)
);
